import React, { Component } from 'react';
import autosize from 'autosize';
import QuestionMark from '../../../../common/icons/questionMark';

class Subtitle2 extends Component {
  componentDidMount() {
    autosize(this.textarea);
  }

  render() {
    const { onSnippetChange, onSnippetDelete, value, index } = this.props;
    const info = '中等尺寸的副標題, 少於副標題1但大於副標题3';

    return (
      <div className='articleEdit-editor-inputContainer'>
        <div className='articleEdit-editor-inputTitleContainer'>
          <div className='title'>副標題2</div>
          <div className='articleEdit-editor-input-rightContainer'>
            <QuestionMark title={info} />
            <i
              className='fa fa-trash icon'
              onClick={() => onSnippetDelete(index)}
            ></i>
          </div>
        </div>
        <textarea
          style={{ height: '30px' }}
          ref={c => (this.textarea = c)}
          onChange={e => onSnippetChange(e, index, 'text')}
          value={value}
        ></textarea>
      </div>
    );
  }
}

export default Subtitle2;
